import { userConstants } from "../../constant";
const initialState = {
  cartItems: [],
};
export function buyerTransactions(state = { initialState }, action) {
  switch (action.type) {
    case userConstants.GET_BUYER_TRANSACTIONS:
      return {
        buyerTransactions: action.transactions,
      };
    default:
      return state;
  }
}
